import OlInteractionSelect from 'ol/interaction/select';
import OlStyleStyle from 'ol/style/style';
import OlStyleStroke from 'ol/style/stroke';
import OlStyleCircle from 'ol/style/circle';
import OlStyleFill from 'ol/style/fill';
import _ from 'lodash';

const defaultSelectStyle = new OlStyleStyle({
    stroke: new OlStyleStroke({
        color: '#2edcd2',
        width: 4
    }),
    fill: new OlStyleFill({
        color: 'rgba(0, 0, 255, 0.0)'
    }),
    image: new OlStyleCircle({
        radius: 6,
        fill: new OlStyleFill({
            color: '#2edcd2'
        })
    })
});

// "_" marks private member
class SelectInteractionManager {
    _selectConfigs = [];
    _selectedFeatures = [];
    _disabled = false;

    _getConfig = (layerName) => {
        return this._selectConfigs.find(config => config.layerName === layerName);
    }

    _onFeatureSelect = (event) => {
        if (event.selected.length > 0) {
            const newFeature = event.selected[0];
            if (newFeature.get('layerName')) {
                const config = this._getConfig(newFeature.get('layerName'));

                // unselect all features on current layer (configurable)           
                this._selectedFeatures.forEach(feature => {
                    if (feature && feature.get('layerName') &&
                        feature.get('layerName') === newFeature.get('layerName') &&
                        feature.get(config.idColumnName) !== newFeature.get(config.idColumnName)) {
                        this._selectedFeatures.remove(feature);
                    }
                });
                // call layer specific event
                if (config && config.onFeatureSelect) {
                    config.onFeatureSelect(newFeature.get(config.idColumnName));
                }
            } else {
                // unselect other features (nonconfigurable)
                this._selectedFeatures.forEach(feature => {
                    if (!feature.get('layerName') && feature.id_ !== newFeature.id_) {
                        this._selectedFeatures.remove(feature);
                    }
                });
            }
        }
        if (event.deselected.length > 0) {
            // reselect feature
            const newFeature = event.deselected[0];
            if (newFeature.get('layerName')) {
                this._selectedFeatures.push(newFeature);
            }
        }
    }

    // remove select interaction when map is unmounted
    removeSelectInteraction = (olMap) => {
        for (let i = 0; i < olMap.interactions.array_.length; i++) {
            if (olMap.interactions.array_[i] instanceof OlInteractionSelect) {
                olMap.removeInteraction(olMap.interactions.array_[i])
            }
        }
        this._selectedFeatures = [];
        this._selectConfigs = [];
        this._disabled = false;
    }

    // create select interaction when map mounting is finished
    createSelectInteraction = (olMap) => {
        const selectInteraction = new OlInteractionSelect({
            style: (feature, resolution) => {
                const config = this._getConfig(feature.get('layerName'));
                if (!config) return defaultSelectStyle;

                return _.isFunction(config.style) ?
                    config.style(feature, resolution) :
                    config.style;
            },
            filter: (feature, layer) => {
                return !this._disabled && layer.get('name') !== "Measurements";
            },
            toggleCondition: (e) => {
                // unselect other features (nonconfigurable)
                this._selectedFeatures.forEach(feature => {
                    if (feature && !feature.get('layerName')) {
                        this._selectedFeatures.remove(feature);
                    }
                });
                return true;
            },
            hitTolerance: 3
        });
        selectInteraction.on('select', this._onFeatureSelect, this);
        this._selectedFeatures = selectInteraction.getFeatures();
        olMap.addInteraction(selectInteraction);
    }

    addSelectConfig = (config) => {
        this._selectConfigs.push(config);
    }

    selectFeature = (layerName, feature) => {
        // disable to stop firing on select event
        const itWasDisable = this._disabled;
        this._disabled = true;

        // unselect all features on current layer
        this._selectedFeatures.forEach(feature => {
            // remove feature after drawing which has no layerName
            if (feature && (!feature.get('layerName') || feature.get('layerName') === layerName)) {
                this._selectedFeatures.remove(feature);
            }
        });

        // select feature
        if (feature && feature.get('layerName')) {
            this._selectedFeatures.push(feature);
        }

        this._disabled = itWasDisable;
    }

    // disable when start editing feature
    disableSelectInteraction = () => {
        this._disabled = true;
    }

    // enable when finish editing feature
    enableSelectInteraction = () => {
        this._disabled = false;
    }
}

// enable to exists separate managers for map and for photoTilesGallery
const selectInteractionManagers = {};
export const getSelectInteractionManager = (managerName) => {
    if (!(managerName in selectInteractionManagers)) {
        selectInteractionManagers[managerName] = new SelectInteractionManager();
    }
    return selectInteractionManagers[managerName];
}


// WEBPACK FOOTER //
// ./src/utilities/selectInteractionManager.js